if (!customElements.get('klevu-tabs')) {
  customElements.define(
    'klevu-tabs',
    class KlevuTabs extends window.BAO.CustomElement() {
      constructor () {
        super()

        this.initialiseTabs()
      }

      initialiseTabs () {
        this.els.trigger.elements.forEach(triggerEl => {
          triggerEl.addEventListener('click', this.handleTrigger.bind(this))
        })
      }

      handleTrigger = event => {
        this.els.trigger.elements.forEach(triggerEl =>
          triggerEl.setAttribute('aria-pressed', triggerEl === event.target),
        )
        this.els.tab.elements.forEach(tabEl => {
          tabEl.setAttribute(
            'aria-hidden',
            tabEl.dataset.tab !== event.target.dataset.tab,
          )

          const klevuCarousel = tabEl.querySelector('klevu-carousel')

          if (tabEl.dataset.tab === event.target.dataset.tab && klevuCarousel) {
            klevuCarousel.initialiseCarousel()
          }
        })
      }
    },
  )
}
